var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"m-notice"}},[(_vm.hasCurrent)?_c('div',{staticClass:"m-notice-frame",on:{"animationend":_vm.clearSelf}},[_c('div',{staticClass:"m-notice-layer"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.txt)}})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }